<template>
  <div class="detail-row">
    <font-awesome-icon v-if="icon != ''" :icon="icon" size="lg" />
    <div
      :class="hasImage ? 'detailtitle hasImage' : 'detailtitle'"
      :style="[icon != '' ? { 'padding-right': '15px' } : '']"
    >
      <b>{{ title }}</b>
    </div>
    <div class="bar"></div>
    <div class="value">
      {{ value }}
      <v-btn
        color="orange white--text"
        rounded
        v-if="showButton"
        @click="$emit('clicked')"
      >
        {{ buttonText }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ["icon", "title", "value", "showButton", "buttonText", "hasImage"],
};
</script>
<style scoped>
.faicon {
  float: right;
  width: 50px;
}

.detailtitle {
  float: right;
  min-width: 15%;
  text-align: right;
}

.value {
  float: right;
  text-align: justify;
  min-width: 80%;
}
.detail-row {
  display: flex;
  margin-left: 15px;
  margin-right: 15px;
  padding: 15px 0px;
}
.bar {
  float: right;
  width: 100%;
  padding: 0px 5px;
  margin-top: 10px;
}

.bar > hr {
  overflow: unset;
}

.v-btn {
  margin-right: 10px;
  top: -5px;
  float: left;
  left: 10px;
}

@media screen and (max-width: 1490px) {
  .value {
    min-width: 70%;
  }
  .detailtitle {
    min-width: 25%;
  }
}

@media screen and (max-width: 1291px) {
  .value {
    min-width: 60%;
  }
  .detailtitle {
    min-width: 35%;
  }
}

@media screen and (max-width: 600px) {
  .hasImage {
    min-width: 50% !important;
  }
}
</style>
